import { Component, Input } from '@angular/core';

@Component({
  selector: 'payarc-empty-state',
  template: `
    <div class="pa-empty">
      <div class="pa-empty__art">
        <svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
          <rect x="10" y="16" width="44" height="30" rx="6"/><path d="M10 26h44"/><path d="M18 38h14" stroke-opacity=".55"/>
        </svg>
      </div>
      <h4 class="pa-empty__title">{{ title }}</h4>
      <p class="pa-empty__msg" *ngIf="message">{{ message }}</p>
      <div class="pa-empty__action"><ng-content></ng-content></div>
    </div>`,
  styleUrls: ['./payarc-empty-state.component.css'],
  standalone: false
})
export class PayarcEmptyStateComponent {
  /** No default — every call site must say what's actually empty, instead of a generic title silently leaking across screens. */
  @Input({ required: true }) title!: string;
  @Input() message?: string;
}
